import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-adfce55e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "load-error"
}
const _hoisted_2 = ["src", "poster"]
const _hoisted_3 = { class: "bezel" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "controller-mask" }, null, -1))
const _hoisted_5 = { class: "controller" }
const _hoisted_6 = { class: "icons icons-left" }
const _hoisted_7 = { class: "icon-content" }
const _hoisted_8 = { class: "volume" }
const _hoisted_9 = { class: "icon-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "thumb" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "ptime" }
const _hoisted_14 = { class: "dtime" }
const _hoisted_15 = { class: "icons icons-right" }
const _hoisted_16 = { class: "speed" }
const _hoisted_17 = { class: "icon speed-icon" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "icon-content" }
const _hoisted_20 = { class: "bar" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "thumb" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

import { computed, ref } from 'vue'
import useMSE from './useMSE'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  src: {
    type: String,
    required: true,
  },
  poster: {
    type: String,
    default: '',
  },
  scale: {
    type: Number,
    default: 1,
  },
},
  setup(__props) {

const props = __props;



const secondToTime = (second = 0) => {
  if (second === 0 || isNaN(second)) return '00:00'

  const add0 = (num: number) => (num < 10 ? '0' + num : '' + num)
  const hour = Math.floor(second / 3600)
  const min = Math.floor((second - hour * 3600) / 60)
  const sec = Math.floor(second - hour * 3600 - min * 60)
  return (hour > 0 ? [hour, min, sec] : [min, sec]).map(add0).join(':')
}

const getBoundingClientRectViewLeft = (element: HTMLElement) => {
  return element.getBoundingClientRect().left
}

const videoRef = ref<HTMLVideoElement>()
const playBarWrap = ref<HTMLElement>()
const volumeBarRef = ref<HTMLElement>()

const volume = ref(0.5)
const paused = ref(true)
const currentTime = ref(0)
const duration = ref(0)
const loaded = ref(0)
const loop = ref(false)
const bezelTransition = ref(false)
const playbackRate = ref(1)

const playBarTimeVisible = ref(false)
const playBarTime = ref('00:00')
const playBarTimeLeft = ref('0')

const ptime = computed(() => secondToTime(currentTime.value))
const dtime = computed(() => secondToTime(duration.value))
const playedBarWidth = computed(() => currentTime.value / duration.value * 100 + '%')
const loadedBarWidth = computed(() => loaded.value / duration.value * 100 + '%')
const volumeBarWidth = computed(() => volume.value * 100 + '%')

const speedMenuVisible = ref(false)
const speedOptions = [
  { label: '2x', value: 2 },
  { label: '1.5x', value: 1.5 },
  { label: '1.25x', value: 1.25 },
  { label: '1x', value: 1 },
  { label: '0.75x', value: 0.75 },
  { label: '0.5x', value: 0.5 },
]

const seek = (time: number) => {
  if (!videoRef.value) return

  time = Math.max(time, 0)
  time = Math.min(time, duration.value)

  videoRef.value.currentTime = time
  currentTime.value = time
}

const play = () => {
  if (!videoRef.value) return

  paused.value = false
  videoRef.value.play()
  bezelTransition.value = true
}

const pause = () => {
  if (!videoRef.value) return

  paused.value = true
  videoRef.value.pause()
  bezelTransition.value = true
}

const toggle = () => {
  if (paused.value) play() 
  else pause()
}

const setVolume = (percentage: number) => {
  if (!videoRef.value) return

  percentage = Math.max(percentage, 0)
  percentage = Math.min(percentage, 1)

  videoRef.value.volume = percentage
  volume.value = percentage
  if (videoRef.value.muted && percentage !== 0) videoRef.value.muted = false
}

const speed = (rate: number) => {
  if (videoRef.value) videoRef.value.playbackRate = rate
  playbackRate.value = rate
}

const handleDurationchange = () => {
  duration.value = videoRef.value?.duration || 0
}

const handleTimeupdate = () => {
  currentTime.value = videoRef.value?.currentTime || 0
}

const handleEnded = () => {
  if (!loop.value) pause()
  else {
    seek(0)
    play()
  }
}

const handleProgress = () => {
  loaded.value = videoRef.value?.buffered.length ? videoRef.value.buffered.end(videoRef.value.buffered.length - 1) : 0
}

const loadError = ref(false)
const handleError = () => loadError.value = true

const thumbMove = (e: MouseEvent | TouchEvent) => {
  if (!videoRef.value || !playBarWrap.value) return
  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  let percentage = (clientX - getBoundingClientRectViewLeft(playBarWrap.value)) / playBarWrap.value.clientWidth
  percentage = Math.max(percentage, 0)
  percentage = Math.min(percentage, 1)
  const time = percentage * duration.value

  videoRef.value.currentTime = time
  currentTime.value = time
}

const thumbUp = (e: MouseEvent | TouchEvent) => {
  if (!videoRef.value || !playBarWrap.value) return

  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  let percentage = (clientX - getBoundingClientRectViewLeft(playBarWrap.value)) / playBarWrap.value.clientWidth
  percentage = Math.max(percentage, 0)
  percentage = Math.min(percentage, 1)
  const time = percentage * duration.value

  videoRef.value.currentTime = time
  currentTime.value = time

  document.removeEventListener('mousemove', thumbMove)
  document.removeEventListener('touchmove', thumbMove)
  document.removeEventListener('mouseup', thumbUp)
  document.removeEventListener('touchend', thumbUp)
}

const handleMousedownPlayBar = () => {
  document.addEventListener('mousemove', thumbMove)
  document.addEventListener('touchmove', thumbMove)
  document.addEventListener('mouseup', thumbUp)
  document.addEventListener('touchend', thumbUp)
}

const volumeMove = (e: MouseEvent | TouchEvent) => {
  if (!volumeBarRef.value) return
  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  const percentage = (clientX - getBoundingClientRectViewLeft(volumeBarRef.value)) / 45
  setVolume(percentage)
}

const volumeUp = () => {
  document.removeEventListener('mousemove', volumeMove)
  document.removeEventListener('touchmove', volumeMove)
  document.removeEventListener('mouseup', volumeUp)
  document.removeEventListener('touchend', volumeUp)
}

const handleMousedownVolumeBar = () => {
  document.addEventListener('mousemove', volumeMove)
  document.addEventListener('touchmove', volumeMove)
  document.addEventListener('mouseup', volumeUp)
  document.addEventListener('touchend', volumeUp)
}

const handleClickVolumeBar = (e: MouseEvent) => {
  if (!volumeBarRef.value) return
  const percentage = (e.clientX - getBoundingClientRectViewLeft(volumeBarRef.value)) / 45
  setVolume(percentage)
}

const handleMousemovePlayBar = (e: MouseEvent) => {
  if (duration.value && playBarWrap.value) {
    const px = playBarWrap.value.getBoundingClientRect().left
    const tx = e.clientX - px
    if (tx < 0 || tx > playBarWrap.value.offsetWidth) return

    const time = duration.value * (tx / playBarWrap.value.offsetWidth)
    playBarTimeLeft.value = `${tx - (time >= 3600 ? 25 : 20)}px`
    playBarTime.value = secondToTime(time)
    playBarTimeVisible.value = true
  }
}

const toggleVolume = () => {
  if (!videoRef.value) return

  if (videoRef.value.muted) {
    videoRef.value.muted = false
    setVolume(0.5)
  }
  else {
    videoRef.value.muted = true
    setVolume(0)
  }
}

const toggleLoop = () => {
  loop.value = !loop.value
}

const autoHideControllerTimer = ref(-1)
const hideController = ref(false)
const autoHideController = () => {
  hideController.value = false
  clearTimeout(autoHideControllerTimer.value)
  autoHideControllerTimer.value = setTimeout(() => {
    if (videoRef.value?.played.length) hideController.value = true
  }, 3000)
}

useMSE(props.src, videoRef)

return (_ctx: any,_cache: any) => {
  const _component_IconPause = _resolveComponent("IconPause")!
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!
  const _component_IconVolumeMute = _resolveComponent("IconVolumeMute")!
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!
  const _component_IconVolumeSmall = _resolveComponent("IconVolumeSmall")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-player", { 'hide-controller': hideController.value }]),
    style: _normalizeStyle({
      width: __props.width * __props.scale + 'px',
      height: __props.height * __props.scale + 'px',
      transform: `scale(${1 / __props.scale})`,
    }),
    onMousemove: _cache[22] || (_cache[22] = ($event: any) => (autoHideController())),
    onClick: _cache[23] || (_cache[23] = ($event: any) => (autoHideController()))
  }, [
    _createElementVNode("div", {
      class: "video-wrap",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (toggle()))
    }, [
      (loadError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "视频加载失败"))
        : _createCommentVNode("", true),
      _createElementVNode("video", {
        class: "video",
        ref_key: "videoRef",
        ref: videoRef,
        src: __props.src,
        poster: __props.poster,
        "webkit-playsinline": "",
        playsinline: "",
        onDurationchange: _cache[0] || (_cache[0] = ($event: any) => (handleDurationchange())),
        onTimeupdate: _cache[1] || (_cache[1] = ($event: any) => (handleTimeupdate())),
        onEnded: _cache[2] || (_cache[2] = ($event: any) => (handleEnded())),
        onProgress: _cache[3] || (_cache[3] = ($event: any) => (handleProgress())),
        onPlay: _cache[4] || (_cache[4] = ($event: any) => (autoHideController())),
        onPause: _cache[5] || (_cache[5] = ($event: any) => (autoHideController())),
        onError: _cache[6] || (_cache[6] = ($event: any) => (handleError()))
      }, null, 40, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["bezel-icon", { 'bezel-transition': bezelTransition.value }]),
          onAnimationend: _cache[7] || (_cache[7] = ($event: any) => (bezelTransition.value = false))
        }, [
          (paused.value)
            ? (_openBlock(), _createBlock(_component_IconPause, { key: 0 }))
            : (_openBlock(), _createBlock(_component_IconPlayOne, { key: 1 }))
        ], 34)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "icon play-icon",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (toggle()))
        }, [
          _createElementVNode("span", _hoisted_7, [
            (paused.value)
              ? (_openBlock(), _createBlock(_component_IconPlayOne, { key: 0 }))
              : (_openBlock(), _createBlock(_component_IconPause, { key: 1 }))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "icon volume-icon",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleVolume()))
          }, [
            _createElementVNode("span", _hoisted_9, [
              (volume.value === 0)
                ? (_openBlock(), _createBlock(_component_IconVolumeMute, { key: 0 }))
                : (volume.value === 1)
                  ? (_openBlock(), _createBlock(_component_IconVolumeNotice, { key: 1 }))
                  : (_openBlock(), _createBlock(_component_IconVolumeSmall, { key: 2 }))
            ])
          ]),
          _createElementVNode("div", {
            class: "volume-bar-wrap",
            onMousedown: _cache[11] || (_cache[11] = ($event: any) => (handleMousedownVolumeBar())),
            onTouchstart: _cache[12] || (_cache[12] = ($event: any) => (handleMousedownVolumeBar())),
            onClick: _cache[13] || (_cache[13] = $event => handleClickVolumeBar($event))
          }, [
            _createElementVNode("div", {
              class: "volume-bar",
              ref_key: "volumeBarRef",
              ref: volumeBarRef
            }, [
              _createElementVNode("div", {
                class: "volume-bar-inner",
                style: _normalizeStyle({ width: _unref(volumeBarWidth) })
              }, _hoisted_11, 4)
            ], 512)
          ], 32)
        ]),
        _createElementVNode("span", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(ptime)), 1),
          _createTextVNode(" / "),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(dtime)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", {
              class: "icon-content",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (speedMenuVisible.value = !speedMenuVisible.value))
            }, _toDisplayString(playbackRate.value === 1 ? '倍速' : (playbackRate.value + 'x')), 1),
            (speedMenuVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "speed-menu",
                  onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (speedMenuVisible.value = false))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(speedOptions, (item) => {
                    return _createElementVNode("div", {
                      class: _normalizeClass(["speed-menu-item", { 'active': item.value === playbackRate.value }]),
                      key: item.label,
                      onClick: ($event: any) => (speed(item.value))
                    }, _toDisplayString(item.label), 11, _hoisted_18)
                  }), 64))
                ], 32))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "loop",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (toggleLoop()))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon loop-icon", { 'active': loop.value }])
          }, [
            _createElementVNode("span", _hoisted_19, "循环" + _toDisplayString(loop.value ? '开' : '关'), 1)
          ], 2)
        ])
      ]),
      _createElementVNode("div", {
        class: "bar-wrap",
        ref_key: "playBarWrap",
        ref: playBarWrap,
        onMousedown: _cache[17] || (_cache[17] = ($event: any) => (handleMousedownPlayBar())),
        onTouchstart: _cache[18] || (_cache[18] = ($event: any) => (handleMousedownPlayBar())),
        onMousemove: _cache[19] || (_cache[19] = $event => handleMousemovePlayBar($event)),
        onMouseenter: _cache[20] || (_cache[20] = ($event: any) => (playBarTimeVisible.value = true)),
        onMouseleave: _cache[21] || (_cache[21] = ($event: any) => (playBarTimeVisible.value = false))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["bar-time", { 'hidden': !playBarTimeVisible.value }]),
          style: _normalizeStyle({ left: playBarTimeLeft.value })
        }, _toDisplayString(playBarTime.value), 7),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: "loaded",
            style: _normalizeStyle({ width: _unref(loadedBarWidth) })
          }, null, 4),
          _createElementVNode("div", {
            class: "played",
            style: _normalizeStyle({ width: _unref(playedBarWidth) })
          }, _hoisted_22, 4)
        ])
      ], 544)
    ])
  ], 38))
}
}

})